import { useState } from 'react';
import { stateMedicaidRate, type ApiClient, type StateMedicaidRate } from '@aithora/shared';
import { sx } from '../../ui/designStyles';

// The state Medicaid rate lookup, restored from the production billing readiness panel
// (billing_readiness_panel.dart). Not in the V3 design: one line under the code catalog,
// for Aithora's billing desk. It shows what is verified and says when it is not: a
// Medicare rate is never shown as a Medicaid one.

const INPUT = 'box-sizing:border-box;height:28px;padding:0 8px;border:1px solid rgba(34,39,46,.18);border-radius:6px;background:#FBF8F1;font-size:14px;color:#22272E;font-family:inherit;';
const STATUS: Record<StateMedicaidRate['status'], string> = { ffs: 'Fee for service', managed_care: 'Managed care only (no separate fee)', unverified: 'Not verified' };

export function MedicaidLookup({ client }: { client: ApiClient }) {
  const [state, setState] = useState('');
  const [cpt, setCpt] = useState('');
  const [out, setOut] = useState<StateMedicaidRate | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const ok = /^[A-Za-z]{2}$/.test(state.trim()) && /^[0-9A-Za-z]{5}$/.test(cpt.trim());
  const look = async () => {
    setErr(null);
    try {
      setOut((await stateMedicaidRate(client, { query: { state: state.trim().toUpperCase(), cpt: cpt.trim().toUpperCase() } })).rate);
    } catch (e) {
      setOut(null);
      setErr(e instanceof Error ? e.message : 'The rate could not be read.');
    }
  };
  return (
    <div data-testid="billing-medicaid" style={sx('flex:0 0 auto;display:flex;align-items:center;gap:6px 8px;flex-wrap:wrap;padding:6px 0;border-bottom:1px solid rgba(34,39,46,.07);min-width:0;')}>
      <span style={sx('font-size:14px;font-weight:700;color:#22272E;')}>Medicaid rate</span>
      <input aria-label="State" placeholder="TX" maxLength={2} value={state} onChange={(e) => setState(e.target.value)} style={sx(INPUT + 'width:46px;')} />
      <input aria-label="Code" placeholder="99492" maxLength={5} value={cpt} onChange={(e) => setCpt(e.target.value)} style={sx(INPUT + 'width:70px;')} />
      <a href="#" aria-disabled={!ok || undefined} onClick={(e) => { e.preventDefault(); if (ok) void look(); }} style={sx('font-size:14px;font-weight:600;color:' + (ok ? '#2F5C97' : '#54606C') + ';text-decoration:none;')}>
        Look up
      </a>
      {out && (
        <span style={sx('flex:1 1 220px;min-width:0;font-size:14px;color:#3C454F;line-height:1.4;')}>
          {[STATUS[out.status], out.cents ? '$' + (out.cents / 100).toFixed(2) : null, out.verified ? 'verified' : 'unverified', out.source ?? out.note ?? null].filter(Boolean).join(' · ')}
        </span>
      )}
      {err && <span role="alert" style={sx('font-size:14px;color:#B3261E;')}>{err}</span>}
    </div>
  );
}
